import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock } from 'react-icons/fa'; // Import lock icon
import '../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/QuestionMockExam.css'; // Assuming you'll reuse or adapt the CSS

const QuestionMockExams = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [subscriptionRequiredForExam, setSubscriptionRequiredForExam] = useState(false);

    const handleMockExamInstruction = async () => {
        setLoading(true);
        setSubscriptionRequiredForExam(false); // Reset this state on click
        const userId = sessionStorage.getItem("userId");

        try {
            const response = await axios.get(`/user/getUserProfile/${userId}`);

            if (response.status === 200) {
                if (response.data.user.currentPlan === "Free") {
                    setSubscriptionRequiredForExam(true);
                } else {
                    navigate("/mock-exam-instruction");
                }
            }

        } catch (err) {
            if (err.response && err.response.status === 402) {
                navigate("/dashboard/subscribe"); // Keep this in case your backend also sends 402 for this route in the future
            } else {
                // Handle other errors if needed
                console.error("Error fetching user profile:", err);
                // Optionally set an error state to display a message to the user
            }

        } finally {
            setLoading(false);
        }
    };

    if (subscriptionRequiredForExam) {
        return (
            <div className="subscription-required-container">
                <FaLock className="lock-icon" />
                <h2 className="subscription-heading">Unlock Mock Exams</h2>
                <p className="subscription-message">
                    Access realistic mock exams requires a premium subscription.
                </p>
                <p className="subscription-benefit">
                    Upgrade now to test your knowledge under exam conditions and improve your preparation.
                </p>
                <button className="upgrade-button" onClick={() => navigate("/dashboard/subscribe")}>
                    Upgrade to Premium
                </button>
                {/* You can add more details or benefits here */}
            </div>
        );
    }

  return (
    <div className="mock-exams-container">
      <h1 className="mock-exams-header">Mock exams</h1>

      <p className="mock-exams-description">
        Mock exams are designed to recreate what you will experience on the day
        of the exam as accurately as possible. As exams increasingly move online
        we've also recreated the kind of interface you'll use. The questions are
        hand picked by our editors to reflect the range and weighting of the
        syllabus. The questions are completely separate from the main question
        bank and the mock exam score will not affect your overall performance
        data. If you are unable to complete the mock exam in one sitting you
        have the option of saving your progress and completing the exam at a
        later date.
      </p>

      <div className="mock-exams-list">
        {/* 
        <div className="mock-exam-card">
          <h2 className="mock-exam-title">Applied Knowledge Test - Mock Exam A</h2>
          <p className="mock-exam-details">
            This mock exam consists of 200 questions over 190 minutes
          </p>
          <button 
            className="mock-exam-button"
            onClick={() => navigate("/mock-exam-instruction")}
          >
            Start this mock exam
          </button>
        </div>
        */}

        <div className="mock-exam-card">
          <h2 className="mock-exam-title">
            Applied Knowledge Test - Mock Exam 
          </h2>
          <p className="mock-exam-details">
            This mock exam consists of 200 questions over 190 minutes
          </p>
          <button onClick={handleMockExamInstruction} disabled={loading} className={loading ? "loading" : ""}>
              Start this mock exam
              {loading && <span className="spinner" aria-label="Loading"></span>}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuestionMockExams;